import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const UserDashboard = () => {
  const { currentUser } = useSelector(state => state.auth);

  return (
    <div className='text-white px-24 py-48'>
      <div className="mx-auto" style={{ maxWidth: 840 }}>
        <h1 className="text-42px mb-24">Welcome, {currentUser?.firstName || 'User'}!</h1>
        
        <div className="bg-accent-dark br-5 p-24 mb-24">
          <h2 className="text-28px mb-16">Your Profile</h2>
          <div className="grid gap-12">
            <div>
              <span className="text-primary-dark">Name:</span> {currentUser?.firstName} {currentUser?.lastName}
            </div>
            <div>
              <span className="text-primary-dark">Email:</span> {currentUser?.email}
            </div>
            <div>
              <span className="text-primary-dark">Username:</span> {currentUser?.username}
            </div>
          </div>
        </div>

        <div className="bg-accent-dark br-5 p-24 mb-24">
          <h2 className="text-28px mb-16">Quick Links</h2>
          <div className="flex flex-col gap-12">
            <Link to="/projects" className="text-primary-dark hover:text-white">
              → Browse All Projects
            </Link>
            <Link to="/about" className="text-primary-dark hover:text-white">
              → About Beck Develops
            </Link>
            <Link to="/#contact" className="text-primary-dark hover:text-white">
              → Contact Us
            </Link>
          </div>
        </div>

        <div className="text-center">
          <p className="text-14px" style={{ color: 'var(--primary-color-dark)' }}>
            This is your user dashboard. More features coming soon!
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;

